import { useQuery } from '@tanstack/react-query';
import {
  listarCategorias,
  listarEmpresasMarketplace,
  obterEmpresaPublica,
  listarCidadesMarketplace,
  type FiltrosDiretorio,
} from '@/services/marketplace.service';

export function useCategorias() {
  return useQuery({
    queryKey: ['categorias'],
    queryFn: listarCategorias,
    staleTime: 5 * 60_000,
  });
}

export function useCidadesMarketplace() {
  return useQuery({
    queryKey: ['mkt-cidades'],
    queryFn: listarCidadesMarketplace,
    staleTime: 5 * 60_000,
  });
}

export function useDiretorio(filtros: FiltrosDiretorio) {
  return useQuery({
    queryKey: ['mkt-empresas', filtros.categoriaSlug ?? null, filtros.cidadeNorm ?? null],
    queryFn: () => listarEmpresasMarketplace(filtros),
  });
}

export function useEmpresaPublica(id: string | undefined) {
  return useQuery({
    queryKey: ['mkt-empresa', id],
    queryFn: () => obterEmpresaPublica(id as string),
    enabled: !!id,
  });
}
